import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { ActionButton } from '../../buttons';

export const CheckoutHeading = styled('h2')`
  font-size: 20px;
  font-weight: 400;
  color: #fff;
`;

export const SummaryToggleButton = styled(ActionButton)`
  background: none;
  color: ${themeGet('colors.blueDarker')};
  text-decoration: underline;
  max-width: 300px;
  min-height: 40px;
`;



// WEBPACK FOOTER //
// ./src/components/views/checkout/style.js